module.exports = __webpack_public_path__ + "static/media/thanks.9fe0cc68.png";